module.exports = __webpack_public_path__ + "dist/img/review-pass.27c81aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review-pass.png
// module id = jmTV
// module chunks = 1